import LoadingBox from 'components/Common/Loading/LoadingBox'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import styled from 'styled-components'
import {
  DRAWER_BODY_HORIZONTAL_PADDING_DESKTOP,
  drawerBodyInlinePaddingStyles,
} from './drawerBodyLayout.styles'

const SkeletonWrapper = styled.div`
  padding-block-start: ${rem(20)};
  padding-block-end: ${rem(20)};
  ${drawerBodyInlinePaddingStyles}

  ${mediaQueryUp.tablet} {
    padding-block-start: ${DRAWER_BODY_HORIZONTAL_PADDING_DESKTOP};
    padding-block-end: ${DRAWER_BODY_HORIZONTAL_PADDING_DESKTOP};
  }
`

const FullWidthLoadingBox = styled(LoadingBox)`
  width: 100%;
`

interface Props {
  title?: string
}

function DrawerDetailLoadingSkeleton({ title }: Props) {
  return (
    <SkeletonWrapper>
      <Group direction="vertical" gap={16}>
        <FullWidthLoadingBox height={200} borderRadius="M" />
        {title ? (
          <Heading variant="heading3">{title}</Heading>
        ) : (
          <TextLoadingBox typography="heading3" width="60%" />
        )}
        <TextLoadingBox typography="body-medium" width="40%" />
        <TextLoadingBox typography="body-medium" width="100%" />
        <TextLoadingBox typography="body-medium" width="80%" />
      </Group>
    </SkeletonWrapper>
  )
}

export default DrawerDetailLoadingSkeleton
